import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketHoldersComponent } from './ticket-holders.component';
import { SwiperModule } from 'swiper/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [TicketHoldersComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    NgxMaskModule.forRoot()
  ]
})
export class TicketHoldersModule { }
